import { MessageCircle, Send } from "lucide-react";

export const WhatsAppFloat = ({ whatsappNumber, telegramLink }) => {
  const waUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent("Hi, I'd like to ask about your products.")}`;
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {telegramLink && (
        <a
          href={telegramLink}
          target="_blank"
          rel="noreferrer"
          className="flex items-center gap-2 bg-[#229ED9] text-white px-5 py-3 rounded-full font-body text-xs uppercase tracking-[0.2em] font-bold hover:bg-[#1b8bc0] transition-colors duration-300"
          data-testid="telegram-float"
        >
          <Send size={18} /> Telegram
        </a>
      )}
      <a
        href={waUrl}
        target="_blank"
        rel="noreferrer"
        className="flex items-center gap-2 bg-[#29FF87] text-[#050805] px-5 py-3 rounded-full font-body text-xs uppercase tracking-[0.2em] font-bold hover:bg-[#5CFFA8] transition-colors duration-300 glow-box"
        data-testid="whatsapp-float"
      >
        <MessageCircle size={18} /> WhatsApp
      </a>
    </div>
  );
};
